import React, {useContext, useEffect, useRef, useState } from 'react'
import axios from "axios";
import { ErrorMessage, Field, Form, Formik,  } from "formik" ;
import toast from "react-hot-toast";
import * as Yup from 'yup';
import { UserContext } from '../../../Context/UserContext.js';
import { CompanyContext } from '../../../Context/CompanyContext.js';
import { BranchContext } from '../../../Context/BranchContext.js';

export default function AddBranchAdmin() {
   const [showPassword , setShowPassword] = useState(false) ;
   const closeBtnRef = useRef() ;
   
   const {userToken } = useContext(UserContext) ;
   const {allCompanyInfo , getAllCompanyInfo } = useContext(CompanyContext) ;
   const {getTypeBranch , getData} = useContext(BranchContext) ;

   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   const handleSubmit = async(values, { resetForm }) => {
      console.log("تم الإرسال:", values);
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/branch/` , values , {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            toast.success("ٍSuccessfully Branch Added")
            getTypeBranch("");
            getData();
         }
      })
      .catch((error)=>{
         toast.error(error.response?.data.message)
      })
      resetForm();
      closeBtnRef.current.click() ;
   };


   const initialValues = {
      name:"",
      email:"",
      phone:"",
      password:"",
      company:"",
      street:"",
      city:"",
      area:""
   };

   const validationSchema = Yup.object({
      name:Yup.string().min(2 , "Name Should be More than 2").max(50 , "Name less than 50").required("Name is Required").trim() ,
      email:Yup.string().email().required().trim() ,
      phone:Yup.string().required().matches(/^01[0125][0-9]{8}$/).trim() ,
      password: Yup.string().min(6, "يجب أن تكون على الأقل 6 حروف").required("كلمة المرور الجديدة مطلوبة").matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]?).{8,}$/ , "Should be Password Start UpperCase And Contain 8 Character And Contain any (@#$%&*)"),
      rePassword: Yup.string().oneOf([Yup.ref("password"), null], "كلمة المرور غير متطابقة").required("تأكيد كلمة المرور مطلوب"),
      company:Yup.string().matches(/^[0-9a-fA-F]{24}$/, 'Invalid ID format').required('ID is required') ,
      street:Yup.string().required().trim() ,
      city:Yup.string().required().trim() ,
      area:Yup.string().required().trim() ,
   });


   useEffect(() => {
      getAllCompanyInfo();
   }, [])
   return (
         <div className="addBranchAdmin-container">
            <div className="modal fade" id="AddBranchAdmin" tabIndex="-1" aria-labelledby="AddBranchAdminLabel" aria-hidden="true">
               <div className="modal-dialog modal-xl">
                  <div className="modal-content">

                     <div className="modal-header">
                        <h5 className="modal-title" id="AddBranchAdminLabel">اضافة بيانات الفرع</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                     </div>

                     <div className="modal-body">
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize >
                           <Form>
                              <div className="mb-3">
                                 <label className="form-label">أسم الفرع</label>
                                 <Field type="text" name="name" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="name" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">أيميل الفرع</label>
                                 <Field type="email" name="email" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="email" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">موبايل الفرع</label>
                                 <Field type="tel" name="phone" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="phone" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">الشركة التابع لها الفرع</label>
                                 <Field as="select" name="company" className="form-select">
                                    <option value="">اختر الشركة</option>
                                    {allCompanyInfo.length > 0 ? 
                                       allCompanyInfo.map((company)=><option value={company._id}>{company.name}</option>): ""}
                                 </Field>
                                 <div className="text-danger"><ErrorMessage name="company" /></div>
                              </div>

                              <div className="mb-3 position-relative">
                                 <label className="form-label">كلمة المرور الجديدة</label>
                                 <Field type={showPassword ? "text" : "password"}   name="password" className="form-control" />
                                 {showPassword ? (
                                          <i className="fas fa-eye toggle-password " onClick={() => setShowPassword(false)}></i>
                                       ) : (
                                          <i className="fas fa-eye-slash toggle-password " onClick={() => setShowPassword(true)}></i>
                                       )
                                 }
                                 <div className="text-danger"><ErrorMessage name="password" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">تأكيد كلمة المرور الجديدة</label>
                                 <Field type={showPassword ? "text" : "password"}   name="rePassword" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="rePassword" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">الشارع</label>
                                 <Field type="text" name="street" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="street" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">المدينة</label>
                                 <Field type="text" name="city" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="city" /></div>
                              </div>

                              <div className="mb-3">
                                 <label className="form-label">المنطقة</label>
                                 <Field type="text" name="area" className="form-control" />
                                 <div className="text-danger"><ErrorMessage name="area" /></div>
                              </div>

                              <div className="d-flex justify-content-end">
                                 <button type="submit" className="btn btn-primary">أضافة فرع</button>
                              </div>
                           </Form>
                        </Formik>
                     </div>

                  </div>
               </div>
            </div>
         </div>
      );
}
